import { ethers } from 'ethers';

/** Use the generic JsonRpcProvider rather than explicit Infura so it is easier to swap in other generic RPCs */
const provider = new ethers.providers.JsonRpcProvider(
  process.env.REACT_APP_NETWORK_JSON_RPC
);

export default provider;
